import { computed, type Ref } from 'vue'
import type { VariantFeedItem } from '#root/types/variants'
import { priceFmt } from './utils'

export function useVariant(
  variant: Ref<VariantFeedItem | null | undefined>
) {
  const description = computed(() => {
    const vnt = variant.value
    if (!vnt) return undefined
    if (vnt.description) return vnt.description
    const p = vnt.product
    if (p && typeof p === 'object' && 'description' in p && p.description)
      return p.description
    return undefined
  })

  const image = computed(() => {
    const vnt = variant.value
    if (!vnt || typeof vnt !== 'object') return undefined
    const vntImg = vnt as {
      list_image?: string | unknown
      person?: { list_image?: string | unknown }
      product?: { list_image?: string | unknown }
    }
    if (vntImg.list_image) return vntImg.list_image
    if (vntImg.person && typeof vntImg.person === 'object' && vntImg.person.list_image)
      return vntImg.person.list_image
    if (vntImg.product && typeof vntImg.product === 'object' && vntImg.product.list_image)
      return vntImg.product.list_image
    return undefined
  })

  const listPriceStr = computed(() => {
    return !variant.value ? '' : priceFmt(variant.value.list_price_usd)
  })

  const name = computed(() => {
    const vnt = variant.value
    if (!vnt) return undefined
    if (vnt.name) return vnt.name
    const p = vnt.product
    if (p && typeof p === 'object' && 'name' in p && p.name) return p.name
    return undefined
  })

  return {
    description,
    image,
    listPriceStr,
    name
  }
}
